import { useTranslation } from 'react-i18next';

import { InfoListModal } from '~settings/components/InfoListModal';
import { UserRoleMap } from '~settings/constants/UserRoleMap';

interface UserRoleInfoModalProps {
  availableUserRoles: { id: string; name: string }[];
}

export function UserRoleInfoModal({
  availableUserRoles,
}: UserRoleInfoModalProps) {
  const { t } = useTranslation('settings');
  const { t: rolesT } = useTranslation('settings', { keyPrefix: 'roles' });

  const items = availableUserRoles.map((role) => ({
    id: role.id,
    title: rolesT(`${UserRoleMap[role.name as keyof typeof UserRoleMap]}.name`),
    description: rolesT(
      `${UserRoleMap[role.name as keyof typeof UserRoleMap]}.description`,
    ),
  }));

  return <InfoListModal title={t('userRoleModal.title')} items={items} />;
}

UserRoleInfoModal.displayName = 'UserRoleInfoModal';
